import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Kasa, KasaClient, ServiceRequest, ServiceRequestClient, TaxesSettlements, TaxesSettlementsDetails} from "src/app/web-api-client";
import { WtStorageService } from "../../../wt-storage.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";

@Component({
  selector: 'app-settlement-details',
  templateUrl: './settlement-details.component.html',
  styleUrls: ['./settlement-details.component.scss']
})
export class SettlementdetailsComponent implements OnInit  {

  public isLoaded = false;
  public settlementDetails: TaxesSettlementsDetails[];
  public settlement: TaxesSettlements;
  public onClose: Subject<void> = new Subject();
  public serviceRequests: ServiceRequest[] = [];
  selectedService: TaxesSettlementsDetails;
   Form: FormGroup;

  constructor(public activeModal: NgbActiveModal,public requestClient:ServiceRequestClient ) { }

  ngOnInit(): void {
    this.loadData();
  }


  loadData() {

    this.isLoaded = false;

    this.requestClient.getList().subscribe((r) => {

      this.serviceRequests = r;
      this.isLoaded = true;
    });

  }
 

  onSubmit() {
   
  }

  getIban() {
    return this.settlementDetails[0].iban;
  }

  getSrName(item: TaxesSettlementsDetails) {
    return this.serviceRequests.find(d => d.idServiceRequest == item.idServiceRequest).firstName +
      ' ' + this.serviceRequests.find(d => d.idServiceRequest == item.idServiceRequest).fammily;
  }
  getSrComission(item: TaxesSettlementsDetails) {
    return this.serviceRequests.find(d => d.idServiceRequest == item.idServiceRequest).serviceAgentComission;
  }
  getSrTax(item: TaxesSettlementsDetails) {
    return this.serviceRequests.find(d => d.idServiceRequest == item.idServiceRequest).serviceProviderTax;
  }

  public onSelected(service: TaxesSettlementsDetails) {
    if (this.isSelected(service)) {
      this.selectedService = null;
    }
    else {

      this.selectedService = service;
    }
  }

  public isSelected(service: TaxesSettlementsDetails): boolean {
    return this.selectedService == service;
  }

  closeModal() {
    this.onClose.next();
    this.activeModal.close();
  }

}
